import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
const SOURCE_GLYPH = {
    context: '◆',
    data: '▦',
    ai_section: '✦',
    asset: '▣',
    unknown: '◇',
};
/**
 * TokenChip - the single, syntax-hidden representation of a document token.
 * A source-tinted capsule with a glyph + humanized label; the raw `{{...}}` is
 * never shown. Used in the editor (as a node view), the canvas preview, the
 * token palette, and the inspector's "tokens in use" list.
 */
export function TokenChip({ label, source = 'unknown', description, value, unbound, onRemove, onClick, className, }) {
    const tip = unbound
        ? 'Unbound token - no matching field or data source'
        : [description, value ? `→ ${value}` : null].filter(Boolean).join('  ·  ') || undefined;
    const inner = (_jsxs(_Fragment, { children: [_jsx("span", { className: "token-chip__glyph", "aria-hidden": true, children: unbound ? '!' : SOURCE_GLYPH[source] }), _jsx("span", { className: "token-chip__label", children: label }), onRemove ? (_jsx("button", { type: "button", className: "token-chip__remove", "aria-label": `Remove ${label}`, onClick: (e) => {
                    e.stopPropagation();
                    onRemove();
                }, children: "\u00D7" })) : null] }));
    const classes = clsx('token-chip', `token-chip--${unbound ? 'unbound' : source}`, onClick && 'token-chip--clickable', className);
    if (onClick) {
        return (_jsx("button", { type: "button", className: classes, title: tip, onClick: onClick, children: inner }));
    }
    return (_jsx("span", { className: classes, title: tip, children: inner }));
}
//# sourceMappingURL=TokenChip.js.map